import { AppPermission, CurrentUser } from '@sdir/auth/lib/types';

interface IAppPermissions {
  CreateApplication: AppPermission;
}

export const OrganizationRole = 'idporten.samferdsel';
export const OrganizationCourseRole = 'idporten.sfd-kurs';
export const OrganizationEndorsementRole = 'idporten.sfd-pategning';
export const OrganizationPaymentRole = 'idporten.sfd-betaling';
export const ExtOrganizationRole = 'externaluser.organizationrepresentative';
export const PersonRole = 'idporten.person';
export const ExternalUserRole = 'externaluser.user';

const serviceIdentifier = 'app-msp-aps';

// All AppPermissions must have the same service identifier
export const AppPermissions: IAppPermissions = {
  CreateApplication: {
    name: `${serviceIdentifier}.Applications.Create`,
    description: 'Access to creating an application in the MSS client.',
  },
};

export const checkIsOrganization = (currentUser?: CurrentUser) => {
  const userRoles = currentUser?.profile?.role || [];
  if (userRoles.indexOf(OrganizationRole) !== -1) return true;
  // Course and Endorsement are relevant in MSP
  if (userRoles.indexOf(OrganizationCourseRole) !== -1) return true;
  if (userRoles.indexOf(OrganizationEndorsementRole) !== -1) return true;
  if (userRoles.indexOf(OrganizationPaymentRole) !== -1) return true;
  if (userRoles.indexOf(ExtOrganizationRole) !== -1) return true;
  return false;
};
